import { MotionConfig } from 'framer-motion';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import AppRoutes from './routes';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      {/*
        reducedMotion="user" 让全站的 framer-motion 动画自动跟随系统的
        "减少动态效果"设置：位移与缩放被跳过，只保留 opacity 过渡。

        这里做全局开关而不是逐个组件调 useReducedMotion —— 光 Contact 一页
        就有 30 处 motion，逐个接的漏改风险比收益大；CSS 的
        prefers-reduced-motion 也管不到 framer-motion，
        因为它是直接写内联 style，不走 transition。
      */}
      <MotionConfig reducedMotion="user">
        <AppRoutes />
      </MotionConfig>
    </BrowserRouter>
  );
};

export default App;
